let baseUrl = "https://api.pidigihub.in";
// let baseUrl = "http://localhost:7002";

export { baseUrl };
